import axios from "axios";

/**
 *
 * @param {*} apiRoutes  : Parametro para hacer una petición a una API especifica
 * @returns : Retorna un array de objetos de la consulta que se hizo
 */

async function setDatos(apiRoutes = "", data = {}) {
  try {
    const instance = axios.create({
      baseURL: `${process.env.REACT_APP_URLBASE}apigeomedellin`,
      method: "POST",
    });
    const { data: responseAxios } = await instance.post(apiRoutes, data);
    return responseAxios;
  } catch (err) {
    throw err;
  }
}

export default setDatos;
